import moment from 'moment-timezone';

const logging = process.env.NODE_ENV === 'development';

export const customLog = (...args: unknown[]) => {
  if (logging) {
    console.log(...args);
  }
};

export const renderRoute = (route: string, vars: Record<string, string>) => {
  return route.replace(/:(\w+)/g, (match, p1) => vars[p1] || match);
};

export const formatDate = (dateString: string): string => {
  return moment(dateString).format('MMM D, YYYY');
};
export const formatDateTime = (dateString: string): string => {
  return moment(dateString)
    .tz('America/Toronto')
    .format('MMM D, YYYY, hh:mm A');
};
export const formatTime = (timeString: string): string => {
  return moment(timeString, 'HH:mm:ss').format('hh:mm A');
};
export const currentDateTime = () => {
  return moment().utc().toISOString();
};
